import i18n from "../../../services/i18n";

const KNOWN_ROLES = ["Admin", "SuperAdmin", "Superuser", "Instructor", "Assistant", "AreaManager", "Staff", "BetaTester", "EndUser"];

/** Rollen-Schlüssel als Klartext (`containers.common.Roles`); unbekannte Rollen bleiben, wie sie sind. */
export const roleLabel = (role: string): string => {
    const labels = i18n.containers.common.Roles as unknown as {[key: string]: (() => string) | undefined};

    return KNOWN_ROLES.includes(role) ? labels[role]?.() ?? role : role;
};
